import React, { useEffect } from 'react'

import { objectToParams } from '../../utils/urls'
import { decryptSecretKey } from '../../utils/encrypt'
import { CART_URL_ENCRYPTION_KEY } from '../../constants/encryption'

const AbandonedCartRedirect = () => {
  const params = new URLSearchParams(window.location.search)
  const paramsObj = Object.fromEntries(params.entries())

  const getUrl = (paramsObj) => {
    const paramsObjDecrypted = decryptSecretKey(paramsObj.url, CART_URL_ENCRYPTION_KEY)
    const decryptedParams = new URLSearchParams(paramsObjDecrypted)
    const decryptedParamsObject = Object.fromEntries(decryptedParams.entries())

    const url = Object.keys(decryptedParamsObject)[0]
    delete decryptedParamsObject.url

    return `${url}?${objectToParams(decryptedParamsObject)}`
  }

  useEffect(() => {
    const url = getUrl(paramsObj)

    setTimeout(() => {
      window.location.href = url
    }, 1000)
  }, [])

  return (
    <div className='flex h-full w-full md:px-5 px-3'>
      <div className='flex flex-col w-full py-2 rounded items-center justify-center'>

        <div className='pl-2 text-xl font-semibold text-gray-800'>
          Estas siendo redirigido a tu carrito abandonado
        </div>

      </div>
    </div>
  )
}

export default AbandonedCartRedirect
